/**************************************************
 * Nombre:       Tarjeta_Articulos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import foto from '../../Recursos/tmp_articulo.png'
import {IconoTexto} from "../Secciones/Componentes/SubComponentes/IconoTexto";
import {CalendarMonthOutlined, KeyboardArrowRight, PersonOutlineOutlined} from '@mui/icons-material'
import {theme} from "../../Tema";
import dayjs from "dayjs";
import {useNavigate} from "react-router";


const Tarjeta_Articulos = ({item}) => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundImage: `url(${item.img})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    height: 250,
                    mb: 1,
                    borderRadius: 1

                }}
            >


            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <IconoTexto Icono={PersonOutlineOutlined} texto={`By ${item.autor}`}/>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                <IconoTexto Icono={CalendarMonthOutlined} texto={dayjs(item.fechaPuclicacion).format('MMMM DD, YYYY')}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: 18, fontWeight: 700, color: theme.palette.primary.main, lineHeight: 1.2}}>
                    {item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 14, fontWeight: 300, color: '#00000090'}}>
                    {item.frase}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Button
                    onClick={() => navigate('/Blog/' + item.id)}
                    color={'primary'} sx={{px: 1, py: 0.8}}>
                    <Typography sx={{px: 2, fontSize: 14}}>
                        Ver Mas
                    </Typography>
                    <IconButton
                        sx={{backgroundColor: '#fff', p: 0.6}}><KeyboardArrowRight/></IconButton></Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Articulos    